module.exports = __webpack_public_path__ + "static/media/bolso (1).079ce804.jpg";